<template>
    <div>
        <!-- <img src="../../static/images/Decs_banner2.png" alt="" class="DescLogo2"> -->
        <div class="container" style="background:#fff;width:100%">
            <h2 class="text-center p-4" style="font-size:34px;font-weight:600;padding-bottom:.25rem!important">{{$t("common.corp")}}</h2>
            <div class="Titleline"></div>
        <div style="padding:10px 0;">
        <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000"
            fade
            indicators
            :interval="4000"
            controls
            img-width="1190"
            img-height="620"
            
        >
            <b-carousel-slide
            v-for="(items,index) in swiperImg" :key="index"
            :caption=items.txt
            :img-src=items.src
            ></b-carousel-slide>
            
        </b-carousel>
        </div>

            
           <div>
                
            
            <p class="Desc_main" v-html="$t(`Home.CorpDesc`)">
                {{$t("Home.CorpDesc")}}
            </p>
           </div>

                
        </div>
    </div>
</template>

<script>
export default {
    data(){

        return{
            swiperImg:[
                {src: require('../../static/Updatedimg/Corp-1.jpg'),
                 txt:' 公司一览 '
                } ,
                {src: require('../../static/Updatedimg/Corp-2.jpg'),
                 txt:'舒适的办公环境'
                },
                {src: require('../../static/Updatedimg/Corp-3.jpg'),
                 txt:'车间一角  '
                }
                  
                
            ]   
        // 视频播放
      

            
    }
    }
    
}
</script>



<style scoped>
@import url('../assets/css/anim.css');

    /* .container h2{
        visibility: hidden;
        animation: top-bottom 1s linear forwards;
    } */
    .DescLogo{
        visibility: hidden;
        animation: bottom-top 1s linear forwards;
        padding-right: 30px;
        width: 50%
    }
    .DescLogo2{
        width: 100%;
    }
    .Desc_main{
        font-size: 16px;
        padding-top: 20px;
        padding-bottom: 30px
    }
    
</style>
